import { getCards } from '@/features/cards/cardsActions';
import { createLoadingSelector, createSelector, selector } from '@/store/utils';

const selectCards = selector((state) => state.cards.items);
export const cardsSelector = createSelector(selectCards);

export const cardsLoadingSelector = createLoadingSelector(getCards);
